import React, { useState } from 'react';
import axios from "axios";
import { Cookies } from '../../index.js';
import { alert_error, alert_success } from '../../AppContext';

const Admin_edit = ({ item, menuHeight, setMenuHeight }) => {
  const [service_name, set_service_name] = useState(item.service_name);
  const [note, set_note] = useState(item.note);
  const [url_redirect, set_url_redirect] = useState(item.url_redirect);
  const [url_mode, set_url_mode] = useState(item.url_mode);
  const [url_stt, set_stt] = useState(item.stt);
  const [url_service_img, set_service_imge] = useState(item.url_mode);
  const [isEditing, setIsEditing] = useState(false);
  const [nutxuly, setnutxuly] = useState(0);
  const [buttonTextjop, setbuttonTextjop] = useState("Xác nhận");
  const [item_edit, set_item_edit] = useState(item);

  const handleChange = (key, value) => {
    set_item_edit((prev) => ({ ...prev, [key]: value }));
  };
  function editting() {
    if (isEditing) {
      setMenuHeight(menuHeight - 400);
    } else {
      setMenuHeight(menuHeight + 400);
    }
    setIsEditing(!isEditing);
  };
  function handleSubmit(event) {
    const myCookieValue = Cookies.get('apikey');
    event.preventDefault();
    setnutxuly(1);
    setbuttonTextjop('Please wait a moment 😊');
    console.log(item_edit);
    axios.post('https://hust.media/jop/ecommerce/category2_edit.php', {
      apikey: myCookieValue,
      mode: 'child',
      item_edit: item_edit
    })
      .then(response => (testFunction(response)))
      .catch(error => console.log(error))

  }
  function testFunction(response) {
    alert_success('thay đổi thành công');
    setnutxuly(0);
  };
  return (
    <div className="p-1 mt-0 border rounded bg-gray-100 text-xs">
      {!isEditing ? (
        <button
          onClick={() => editting()}
          className="w-full px-2 py-0 text-white bg-pink-300 rounded hover:bg-blue-600"
        >
          Edit
        </button>
      ) : (
        <>
          <button
            onClick={() => editting()}
            className="w-full px-2 py-0 text-white bg-red-500 rounded hover:bg-red-600"
          >
            Đóng
          </button>
          <label className="block font-medium text-gray-700">Tên dịch vụ:</label>
          <input
            type="text"
            value={item_edit.service_name}
            onChange={(e) => handleChange("service_name", e.target.value)}
            className="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-1 focus:ring-pink-300"
          />

          <label className="block font-medium text-gray-700 mt-1">Ghi chú:</label>
          <input
            type="text"
            value={item_edit.note}
            onChange={(e) => handleChange("note", e.target.value)}
            className="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-1 focus:ring-pink-300"
          />

          <label className="block font-medium text-gray-700 mt-1">URL Redirect:</label>
          <input
            type="text"
            value={item_edit.url_redirect}
            onChange={(e) => handleChange("url_redirect", e.target.value)}
            className="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-1 focus:ring-pink-300"
          />

          <label className="block font-medium text-gray-700 mt-1">URL Mode:</label>
          <input
            type="text"
            value={item_edit.url_mode}
            onChange={(e) => handleChange("url_mode", e.target.value)}
            className="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-1 focus:ring-pink-300"
          />

          <label className="block font-medium text-gray-700 mt-1">STT:</label>
          <input
            type="text"
            value={item_edit.stt}
            onChange={(e) => handleChange("stt", e.target.value)}
            className="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-1 focus:ring-pink-300"
          />

          <label className="block font-medium text-gray-700 mt-1">Service Image:</label>
          <input
            type="text"
            value={item_edit.service_img}
            onChange={(e) => handleChange("service_img", e.target.value)}
            className="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-1 focus:ring-pink-300"
          />
          <label className="block font-medium text-gray-700 mt-1">Thể loại:</label>
          <input
            type="text"
            value={item_edit.category}
            onChange={(e) => handleChange("service_img", e.target.value)}
            className="w-full px-1 py-0.5 border rounded focus:outline-none focus:ring-1 focus:ring-pink-300"
          />
          <button onClick={handleSubmit}
            className='mt-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
            <div className='flex items-center justify-between flex-1'>
              {nutxuly == 1 && (
                <div className="spinner-border" role="status">

                </div>
              )}


              <span className='text-lg font-medium text-white'>
                {buttonTextjop} </span>
                <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
            </div>
          </button>
        </>
      )}
    </div>
  );
};

export default Admin_edit;